var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
var variantsHidden = false;
// Override Settings
var bcSfFilterSettings = {
  general: {
    limit: bcSfFilterConfig.custom.products_per_page,
    /* Optional */
    loadProductFirst: false,
    // Placeholder
    showPlaceholderProductList: true,
    placeholderProductPerRow: 6
  }
};



// 1) Template : collection.liquid

// Works without any special logic.

// 2) Template : collection.hide-liquidation.
// collections/all
// Hides any variants that are on liquidation and it also hides the products that has all the variants on liquidation.

// 3) Template: collection.liquidation-only
// collections/liquidation
// Hides the variants that are not on liquidation and it also hides the products that doesn't have any variants on liquidation.

// Declare Templates
var bcSfFilterTemplate = {
  'soldOutClass': 'product--soldout',
  'saleClass': ' on-sale',
  'soldOutLabelHtml': '<span class="soldout bc-sf-filter-label">' + bcSfFilterConfig.label_basic.sold_out + '</span>',
  'saleLabelHtml': '<span class="sale bc-sf-filter-label">' + bcSfFilterConfig.label_basic.sale + '</span>',
  'tagLabelHtml': '<span class="tag bc-sf-filter-label {{labelTag}}" >{{labelTag}}</span>',
  'vendorHtml': '<h5 class="slighter base--tablet_portrait flat_bottom uppercase">{{itemVendorLabel}}</h5>',
  // Grid Template
  'productGridItemHtml': '<div class="bc-sf-filter-product-item bc-sf-filter-product-item-grid {{gridWidthClass}}{{soldOutClass}}{{saleClass}} {{itemActiveSwapClass}}" data-collection-product>' +
    '<script class="bc-sf-filter-product-script" data-id="bc-product-json-{{itemId}}" type="application/json">{{itemJson}}</script>' +
    '<div class="product {{soldOutClass}}">' +
    '<a href="{{itemUrl}}">' +
    '<div class="product__img">' +
    '{{discountFlag}}' +
    '{{itemImages}}' +
    '</div>' +
    '</a>' +
    //'<div class="quick-view-button"><a class="quick-view" href="javascript:void(0);" id="{{itemId}}" data-handle="{{itemHandle}}">Quick View</a></div>' +
    '{{itemSale}}' +
    '<div class="product__text text_left">' +
    '<div class="grid product__grid">' +
    '<div class="col product__info">' +
    '<a href="{{itemUrl}}">' +
    '{{itemVendor}}' +
    '<div class="product__title"><h4 class="body_font base small--tablet_portrait flat_bottom">{{itemTitle}}</h4></div>' +
    '</a>' +
    '<div class="normal_top">{{itemPrice}}</div>' +
    '</div>' +
    '{{itemSwatch}}' +
    '</div>' +
    '</div>' +
    '</div>' +
    '</div>',
  // For List View
  // List Template
  'productListItemHtml': '<div class="bc-sf-filter-product-item bc-sf-filter-product-item-grid {{gridWidthClass}}{{soldOutClass}}{{saleClass}} {{itemActiveSwapClass}}" data-collection-product>' +
    '<script class="bc-sf-filter-product-script" data-id="bc-product-json-{{itemId}}" type="application/json">{{itemJson}}</script>' +
    '<div class="product {{soldOutClass}}">' +
    '<div class="product__img">' +
    '{{discountFlag}}' +
    '<a href="{{itemUrl}}">{{itemImages}}</a>' +
    '</div>' +
    '{{itemSale}}' +
    '<div class="product__text text_left">' +
    '<div class="grid">' +
    '<div class="col grid__grow">' +
    '<a href="{{itemUrl}}">' +
    '{{itemVendor}}' +
    '<div class="product__title"><h4 class="body_font base small--tablet_portrait flat_bottom">{{itemTitle}}</h4></div>' +
    '</a>' +
    '<div class="normal_top">{{itemPrice}}</div>' +
    '</div>' +
    '{{itemSwatch}}' +
    '</div>' +
    '</div>' +
    '</div>' +
    '</div>',
  //     'productListItemHtml': '<div class="bc-sf-filter-product-item bc-sf-filter-product-item-grid {{gridWidthClass}}{{soldOutClass}}{{saleClass}} {{itemActiveSwapClass}}">' +
  //                                 '<div class="bc-sf-filter-product-item-list-col-1">' +
  //                                     '<div class="bc-sf-filter-product-item-image">' +
  //                                         '<div class="bc-sf-filter-product-item-label">{{itemLabels}}{{itemTagLabels}}</div>' +
  //                                         '<a href="{{itemUrl}}" class="bc-sf-filter-product-item-image-link">{{itemImages}}</a>' +
  //                                     '</div>' +
  //                                 '</div>' +
  //                                 '<div class="bc-sf-filter-product-bottom">' +
  //                                     '<div class="bc-sf-filter-product-item-list-col-2">' +
  //                                         '<a href="{{itemUrl}}" class="bc-sf-filter-product-item-title">{{itemTitle}}</a>' +
  //                                         '{{itemVendor}}' +
  //                                         '<p class="bc-sf-filter-des">{{itemDescription}}</p>' +
  //                                         '<div class="bc-sf-filter-product-link">' +
  //                                             '<a href="{{itemUrl}}" class="button">View Product</a>' +
  //                                         '</div>' +
  //                                     '</div>' +
  //                                     '<div class="bc-sf-filter-product-item-list-col-3">' +
  //                      '{{itemPrice}}' + 
  //                      '{{itemSwatch}}' +
  //                    '</div>' +
  //                                 '</div>'+
  //                             '</div>',
  // End For List View
  // Pagination Template
  'previousActiveHtml': '<li><a href="{{itemUrl}}">&larr;</a></li>',
  'previousDisabledHtml': '<li class="disabled"><span>&larr;</span></li>',
  'nextActiveHtml': '<li><a href="{{itemUrl}}">&rarr;</a></li>',
  'nextDisabledHtml': '<li class="disabled"><span>&rarr;</span></li>',
  'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
  'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
  'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
  'paginateHtml': '<ul>{{previous}}{{pageItems}}{{next}}</ul>',
  // Sorting Template
  'sortingHtml': '<label><span><span>' + bcSfFilterConfig.label.sorting + '</span></span></label><ul class="bc-sf-filter-filter-dropdown">{{sortingItems}}</ul>',
  // Show Limit Template
  'showLimitHtml': '<label>' + bcSfFilterConfig.label.show_limit + '</label><select class="bc-sf-filter-filter-dropdown">{{showLimitItems}}</select>',
  // Breadcrumb Template
  'breadcrumbHtml': '<a href="/">' + bcSfFilterConfig.label.breadcrumb_home + '</a> {{breadcrumbDivider}} {{breadcrumbItems}}',
  'breadcrumbDivider': '<span class="divider">/</span>',
  'breadcrumbItemLink': '<a href="{{itemLink}}">{{itemTitle}}</a>',
  'breadcrumbItemSelected': '<span>{{itemTitle}}</span>',
};
/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
function prepareShopifyData(data) {
  // Displaying price base on the policy of Shopify, have to multiple by 100
  soldOut = !data.available; // Check a product is out of stock
  onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Convert images to array
  images = data.images_info;
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function (e) {
      return e.id == getParam('variant');
    });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  return data;
}

function prepareHideLiquidation(data) {
  data.original_variants = data.variants;
  // console.log(data)
  //   var listOfVariantsInLiquidation = data.variants.filter(function(variant){
  //     return data.metafields.filter( function(metafield){
  //       return metafield.key === "price_change_code" && metafield.namespace === variant.id && metafield.value !== null && metafield.value !== "null" && metafield.value !== "" && metafield.value.toLowerCase() === "liquidation"
  //     }).length > 0
  //   })
  //   var listOfVariantsNotLiquidation = data.variants.filter(function(variant){
  //     return listOfVariantsInLiquidation.findIndex( function(variantLiquidation){
  //       return variant.id === variantLiquidation.id
  //     }) === -1
  //   })
  var listOfVariantsNotLiquidation = data.variants.filter(function (variant) {
    return !variant.liquidation
  })
  data.variants = listOfVariantsNotLiquidation;
  if (listOfVariantsNotLiquidation.length === 0) return false
  if (listOfVariantsNotLiquidation.length !== data.variants.length) {

    listOfVariantsNotLiquidation.sort(function (a, b) {
      return a.price - b.price;
    });

    data.price_min = listOfVariantsNotLiquidation[0].price;
    data.price_max = listOfVariantsNotLiquidation[listOfVariantsNotLiquidation.length - 1].price;
    var comparePriceVariants = listOfVariantsNotLiquidation.filter(function (variant) {
      return !isNaN(parseFloat(variant.compare_at_price))
    })

    if (comparePriceVariants.length > 0) {
      data.compare_at_price_min = comparePriceVariants[0].compare_at_price;
      data.compare_at_price_max = comparePriceVariants[comparePriceVariants.length - 1].compare_at_price;
    }
    data.original_images_info = data.images_info;
    data.images_info = data.images_info.filter(function (image) {
      return data.variants.filter(function (variant) {
        return variant.image === image.src
      }).length > 0
    })

    variantsHidden = true;
  } else {
    variantsHidden = false;
  }
  return data;
}

function prepareLiquidation(data) {
  data.original_variants = data.variants;
  //   var listOfVariantsInLiquidation = data.variants.filter(function(variant){
  //     return data.metafields.filter( function(metafield){
  //       return metafield.key === "price_change_code" && metafield.namespace === variant.id && metafield.value !== null && metafield.value !== "null" && metafield.value !== ""  && metafield.value.toLowerCase() === "liquidation"
  //     }).length > 0
  //   })
  var listOfVariantsInLiquidation = data.variants.filter(function (variant) {
    return variant.liquidation
  })

  if (listOfVariantsInLiquidation.length === 0) return false
  if (listOfVariantsInLiquidation.length !== data.variants.length) {
    data.variants = listOfVariantsInLiquidation;
    listOfVariantsInLiquidation.sort(function (a, b) {
      return a.price - b.price;
    });
    var comparePriceVariants = listOfVariantsInLiquidation.filter(function (variant) {
      return !isNaN(parseFloat(variant.compare_at_price))
    })

    if (comparePriceVariants.length > 0) {
      data.compare_at_price_min = comparePriceVariants[0].compare_at_price;
      data.compare_at_price_max = comparePriceVariants[comparePriceVariants.length - 1].compare_at_price;
    }
    data.original_images_info = data.images_info;
    data.images_info = data.images_info.filter(function (image) {
      return data.variants.filter(function (variant) {
        return variant.image === image.src
      }).length > 0
    })
    // console.log(data.images_info)
    variantsHidden = true;
  } else {
    variantsHidden = false;
  }
  return data;
}

function appendVariantMetafields(data) {
  var variantMetafieldArray = data.metafields.filter(function (metafield) {
    return metafield.key === "price_change_code" && (metafield.value.toLowerCase() === "liquidation" || metafield.value.toLowerCase() === "regular")
  })
  data.variants.forEach(function (variant) {
    variantMetafieldArray.forEach(function (metafield) {
      if (variant.id === metafield.id && metafield.value.toLowerCase() === "liquidation") {
        variant.liquidation = true;
      } else if (variant.id === metafield.id && metafield.value.toLowerCase() === "regular") {
        variant.liquidation = false;
      }
    })
  })
  data.variants.forEach(function (variant) {
    if (!variant.hasOwnProperty("liquidation")) {
      variant.liquidation = false;
    }
  })
  return data;
}
/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function (data, index) {
  // Get Template
  var itemHtml = bcSfFilterTemplate.productGridItemHtml;

  data = appendVariantMetafields(data);
  // Customize API data to get the Shopify data
  if (bcSfFilterMainConfig.general.template === "collection.liquidation-only") {
    data = prepareLiquidation(data)
  } else if (bcSfFilterMainConfig.general.template === "collection.hide-liquidation") {
    data = prepareHideLiquidation(data)
  }
  if (data === false) return '';
  data = prepareShopifyData(data);
  // Add Custom class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
  // Add Grid Width class
  itemHtml = itemHtml.replace(/{{gridWidthClass}}/g, buildGridWidthClass(data));
  // Add Label
  itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
  // Add TAG Label
  itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
  // Add Images
  itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
  // Add Price
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
  // Add Vendor
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
  // Add Swatch
  itemHtml = itemHtml.replace(/{{itemSwatch}}/g, buildSwatch(data));
  // itemActiveSwapClass
  var itemActiveSwapClass = bcSfFilterConfig.custom.active_image_swap ? 'has-bc-swap-image' : '';
  itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass);

  itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSale(data));

  // Add Sale Flag
  itemHtml = itemHtml.replace(/{{discountFlag}}/g, buildSaleFlag(data));

  // Add data json
  var self = this;
  var itemJson = {
    "id": data.id,
    "title": data.title,
    "handle": data.handle,
    "vendor": data.vendor,
    "variants": data.variants,
    "url": self.buildProductItemUrl(data),
    "options_with_values": data.options_with_values,
    "images": data.images,
    "available": data.available,
    "price_min": data.price_min,
    "price_max": data.price_max,
    "compare_at_price_min": data.compare_at_price_min,
    "compare_at_price_max": data.compare_at_price_max
  };
  itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(itemJson));

  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
  itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
  return itemHtml;
};
// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function (data) {
  // For List View
  /*** Prepare data ***/
  var images = data.images_info;
  // Displaying price base on the policy of Shopify, have to multiple by 100
  var soldOut = !data.available; // Check a product is out of stock
  var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  var priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function (e) {
      return e.id == getParam('variant');
    });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  /*** End Prepare data ***/
  // Get Template
  var itemHtml = bcSfFilterTemplate.productListItemHtml;
  // Customize API data to get the Shopify data
  data = prepareShopifyData(data);
  // Add Custom class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
  // Add Grid Width class
  itemHtml = itemHtml.replace(/{{gridWidthClass}}/g, buildGridWidthClass(data));
  // Add Label
  itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
  // Add TAG Label
  itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
  // Add Images
  itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
  // Add Vendor
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
  // Add Price
  var itemPriceHtml = buildPrice(data, onSale, priceVaries);
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
  // Description
  var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
  itemDescription = (itemDescription.split(" ")).length > 40 ? itemDescription.split(" ").splice(0, 40).join(" ") + '...' : itemDescription.split(" ").splice(0, 40).join(" ");
  itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
  // Add Swatch
  itemHtml = itemHtml.replace(/{{itemSwatch}}/g, buildSwatch(data));
  // itemActiveSwapClass
  var itemActiveSwapClass = bcSfFilterConfig.custom.active_image_swap ? 'has-bc-swap-image' : '';
  itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass);
  // Add data json
  var self = this;
  var itemJson = {
    "id": data.id,
    "title": data.title,
    "handle": data.handle,
    "vendor": data.vendor,
    "variants": data.variants,
    "url": self.buildProductItemUrl(data),
    "options_with_values": data.options_with_values,
    "images": data.images,
    "available": data.available,
    "price_min": data.price_min,
    "price_max": data.price_max,
    "compare_at_price_min": data.compare_at_price_min,
    "compare_at_price_max": data.compare_at_price_max
  };
  itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(itemJson));

  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
  itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
  return itemHtml;
  // End For List View
};
/************************** END BUILD PRODUCT LIST **************************/
/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
function buildGridWidthClass() {
  var gridWidthClass = '';
  var perRow = bcSfFilterConfig.custom.products_per_row;
  var perRowMobile = bcSfFilterConfig.custom.products_per_row_mobile;
  if (bcsffilter.queryParams.display == 'list') {
    perRow = 4;
    perRowMobile = 1;
  }
  // On PC
  switch (perRow) {
    case 2:
      gridWidthClass = 'bc-sf-filter-grid-width-2';
      break;
    case 3:
      gridWidthClass = 'bc-sf-filter-grid-width-3';
      break;
    case 5:
      gridWidthClass = 'bc-sf-filter-grid-width-5';
      break;
    default:
      gridWidthClass = 'bc-sf-filter-grid-width-4';
      break;
  }
  // On Mobile
  switch (perRowMobile) {
    case 1:
      gridWidthClass += ' bc-sf-filter-grid-width-mb-1';
      break;
    case 3:
      gridWidthClass += ' bc-sf-filter-grid-width-mb-3';
      break;
    default:
      gridWidthClass += ' bc-sf-filter-grid-width-mb-2';
      break;
  }
  return gridWidthClass;
}

function buildImages(data) {
  var html = '';
  // Build Main Image
  var loadingUrl = bcSfFilterConfig.general.loading_icon_url;
  var thumbUrl = images.length > 0 ? bcsffilter.optimizeImage(images[0]['src'], 'x600') : bcSfFilterConfig.general.no_image_url;
  html += '<img data-src="' + thumbUrl + '" src="' + loadingUrl + '" class="bc-sf-filter-product-item-main-image lazyload image" data-featured-img="' + thumbUrl + '" />';
  // Build Image Swap
  if (bcSfFilterConfig.custom.active_image_swap) {
    var flipImageUrl = images.length > 1 ? bcsffilter.optimizeImage(images[1]['src'], 'x600') : thumbUrl;
    html += '<img data+src="' + flipImageUrl + '" src="' + loadingUrl + '" class="bc-sf-filter-product-item-flip-image lazyload image" />';
  }
  return html;
}

function buildSale(data) {
  var html = '';

  var avaiVariants = [];

  // if(data['compare_at_price'] > data['price']){
  //     formattedPrice = data['price']/100;
  //     if(formattedPrice == Math.floor(formattedPrice)) {
  //         html += '<div class="bc-sf-filter-product-item-tag">Liquidation</div>';
  //     }
  // }
  for (var i = 0; i < data['variants'].length; i++) {
    if (data['variants'][i].hasOwnProperty('option3')) {
      if (avaiVariants.indexOf(data['variants'][i]['option3']) == -1) {
        avaiVariants.push(data['variants'][i]['option3']);

        id = data['variants'][i].id;
        // console.log(data['metafields'], id);
        liquidationField = _.findWhere(data['metafields'], { id: id, key: "price_change_code" });

        html += '<div class="';
        if (i > 0) {
          html += 'hide"';
        } else {
          html += '"';
        }

        html += ' data-product-tag="' + data['variants'][i]['id'] + '">';


        if (liquidationField && liquidationField.value === 'Liquidation') {
          html += '<div class="product__sale '
          if(bcSfFilterConfig.custom.show_discount_flag) {
            html += 'has-flag';
          }
          html += '"><span class="translatable">Clearance</span></div>';
        }

        html += '</div>';
      }
    }

  }

  return html;

}

function buildVendor(data) {
  var html = '';
  if (bcSfFilterConfig.custom.show_vendor) {
    html = bcSfFilterTemplate.vendorHtml;
  }
  return html;
}

function buildPrice(data) {
  var html = '';

  var avaiVariants = [];

  if (bcSfFilterConfig.custom.activate_map_price) {
    for (var g = 0; g < data['tags'].length; g++) {
      var tagSplit = data['tags'][g].split(':')
      if (tagSplit[0] == 'MAP PRICING' && tagSplit[1]) {
        var mapPrice = parseFloat(tagSplit[1]) * 100;
      }
    }
  }

  if (bcSfFilterConfig.custom.show_price) {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].hasOwnProperty('option3')) {
        if (avaiVariants.indexOf(data['variants'][i]['option3']) == -1) {
          avaiVariants.push(data['variants'][i]['option3']);

          var price = data['variants'][i]['price'];
          if (mapPrice && mapPrice > data['variants'][i]['price']) {
            price = mapPrice;
          }

          html += '<div class="product__price';
          if (i > 0) {
            html += ' hide"';
          } else {
            html += '"';
          }
          html += ' data-product-price="' + data['variants'][i]['id'] + '">';

          if ((window.loyalty.isVIP || window.loyalty.isCartVIP) && window.loyalty.eligible.includes(data['id'])) {
            if (data['variants'][i]['compare_at_price'] > price) {
              html += '<span class="price">';
              html += '<span class="vip-price">' + bcsffilter.formatMoney(price * (1 - window.loyalty.discount)) + '</span>';
              html += '<span class="selling-price">' + bcsffilter.formatMoney(price) + '</span>';
              html += '<span class="compare-price">' + bcsffilter.formatMoney(data['variants'][i]['compare_at_price']) + '</span>';
              html += '</span>';
            } else {
              html += '<span class="price">';
              html += '<span class="vip-price">' + bcsffilter.formatMoney(price * (1 - window.loyalty.discount)) + '</span>';
              html += '<span class="compare-price">' + bcsffilter.formatMoney(price) + '</span>';
              html += '</span>';
            }
          } else {
            if (data['variants'][i]['compare_at_price'] > price) {
              html += '<span class="price">';
              html += '<span class="selling-price">' + bcsffilter.formatMoney(price) + '</span>';
              html += '<span class="compare-price">' + bcsffilter.formatMoney(data['variants'][i]['compare_at_price']) + '</span>';
              html += '</span>';
            } else {
              html += '<span class="price">';
              html += '<span class="compare-price">' + bcsffilter.formatMoney(price) + '</span>';
              html += '</span>';
            }
          }
          html += '</div>';
        }
      } else {
        var price = data['variants'][i]['price'];
        console.log(data.title, data['variants'][i].title, price);
        if (mapPrice && mapPrice > data['variants'][i]['price']) {
          price = mapPrice;
        }

        html += '<div class="product__price';
        if (i > 0) {
          html += ' hide"';
        } else {
          html += '"';
        }
        html += ' data-product-price="' + data['variants'][i]['id'] + '">';

        if ((window.loyalty.isVIP || window.loyalty.isCartVIP) && window.loyalty.eligible.includes(data['id'])) {
          if (data['variants'][i]['compare_at_price'] > price) {
            html += '<span class="price">';
            html += '<span class="vip-price">' + bcsffilter.formatMoney(price * (1 - window.loyalty.discount)) + '</span>';
            html += '<span class="selling-price">' + bcsffilter.formatMoney(price) + '</span>';
            html += '<span class="compare-price">' + bcsffilter.formatMoney(data['variants'][i]['compare_at_price']) + '</span>';
            html += '</span>';
          } else {
            html += '<span class="price">';
            html += '<span class="vip-price">' + bcsffilter.formatMoney(price * (1 - window.loyalty.discount)) + '</span>';
            html += '<span class="compare-price">' + bcsffilter.formatMoney(price) + '</span>';
            html += '</span>';
          }
        } else {
          if (data['variants'][i]['compare_at_price'] > price) {
            html += '<span class="price">';
            html += '<span class="selling-price">' + bcsffilter.formatMoney(price) + '</span>';
            html += '<span class="compare-price">' + bcsffilter.formatMoney(data['variants'][i]['compare_at_price']) + '</span>';
            html += '</span>';
          } else {
            html += '<span class="price">';
            html += '<span class="compare-price">' + bcsffilter.formatMoney(price) + '</span>';
            html += '</span>';
          }
        }
        html += '</div>';
      }
    }
  }

  // if (bcSfFilterConfig.custom.show_price) {
  //   html = '<p class="bc-sf-filter-product-item-price">';
  //   if (onSale) {
  //     html += '<s>' + bcsffilter.formatMoney(data.compare_at_price_min) + '</s> ';
  //     html += '<span class="bc-sf-filter-product-item-sale-price">' + bcsffilter.formatMoney(data.price_min) + '</span>';
  //   } else {
  //     if (priceVaries) {
  //       html += (bcSfFilterConfig.label_basic.from) + ' ';
  //     }
  //     html += '<span class="bc-sf-filter-product-item-regular-price">' + bcsffilter.formatMoney(data.price_min) + '</span>';
  //   }
  //   html += '</p>';
  // }
  return html;
}

function buildSaleFlag(data) {
  var html = '';

  if (bcSfFilterConfig.custom.show_discount_flag) {
    var discount = 1;
    for (var i = 0; i < data['variants'].length; i++) {
      html += '<div class="';
      if (i > 0) {
        html += ' hide"';
      } else {
        html += '"';
      }
      html += ' data-product-tag="' + data['variants'][i]['id'] + '">';

      var price = data['variants'][i]['price'];
      if ((window.loyalty.isVIP || window.loyalty.isCartVIP) && window.loyalty.eligible.includes(data['id'])) {
        if (data['variants'][i]['compare_at_price'] > price) {
          discount = price * (1 - window.loyalty.discount) / data['variants'][i]['compare_at_price'];
        } else {
          discount = price * (1 - window.loyalty.discount) / price;
        }
      } else {
        if (data['variants'][i]['compare_at_price'] > price) {
          discount = price / data['variants'][i]['compare_at_price'];
          // console.log("wtf", discount);
        } else {
          discount = 1;
        }
      }
      discount = Math.round((1 - discount) * 100);
      if (discount >= 17.5) {
        if ((window.loyalty.isVIP || window.loyalty.isCartVIP) && window.loyalty.eligible.includes(data['id'])) {
          html += '<div class="discount-flag vip-flag">';
        } else {
          html += '<div class="discount-flag">';
        }
        if (discount >= 17.5 && discount < 22.5) {
          html += '-20%';
        } else if (discount >= 22.5 && discount < 27.5) {
          html += '-25%';
        } else if (discount >= 27.5 && discount < 32.5) {
          html += '-30%';
        } else if (discount >= 32.5 && discount < 37.5) {
          html += '-35%';
        } else if (discount >= 37.5 && discount < 42.5) {
          html += '-40%';
        } else if (discount >= 42.5 && discount < 47.5) {
          html += '-45%';
        } else if (discount >= 47.5 && discount < 52.5) {
          html += '-50%';
        } else if (discount >= 52.5 && discount < 57.5) {
          html += '-55%';
        } else if (discount >= 57.5 && discount < 62.5) {
          html += '-60%';
        } else if (discount >= 62.5 && discount < 67.5) {
          html += '-65%';
        } else if (discount >= 67.5 && discount < 72.5) {
          html += '-70%';
        } else if (discount >= 72.5 && discount < 77.5) {
          html += '-75%';
        } else if (discount >= 77.5 && discount < 82.5) {
          html += '-80%';
        } else if (discount >= 82.5 && discount < 87.5) {
          html += '-85%';
        } else if (discount >= 87.5 && discount < 92.5) {
          html += '-90%';
        } else if (discount >= 92.5 && discount < 97.5) {
          html += '-95%';
        }
        html += '</div>';
      }
      html += '</div>';
    }
  }
  return html;
}

function buildLabels(data) {
  // Build Sold out label
  var soldOutLabel = '';
  if (bcSfFilterConfig.custom.show_sold_out_label && soldOut) {
    soldOutLabel = bcSfFilterTemplate.soldOutLabelHtml.replace(/{{style}}/g, '');
  }
  // Build Sale label
  var saleLabel = '';
  if (bcSfFilterConfig.custom.show_sale_label && onSale && !soldOut) {
    saleLabel = bcSfFilterTemplate.saleLabelHtml.replace(/{{style}}/g, '');
  }
  // Build Labels
  return soldOutLabel + saleLabel;
}
// BUILD LABEL PRODUCT WITH TAGS
function buildTagLabels(data, showall) {
  if (showall) {
    var tagLabel = '';
    if (data.tags) {
      for (var i = 0; i < data.tags.length; i++) {
        var tag = data.tags[i];
        if (tag.indexOf("pfs:label") !== -1) {
          var preTagLabel = bcSfFilterTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
          tagLabel += preTagLabel;
        }
      }
    }
  } else {
    var tagLabel = '';
    if (data.tags) {
      for (var i = data.tags.length - 1; i >= 0; i--) {
        tag = data.tags[i];
        if (tag.indexOf("pfs:label") !== -1) {
          var preTagLabel = bcSfFilterTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
          tagLabel += preTagLabel;
          break;
        }
      }
    }
  }
  return tagLabel;
}

function buildSwatch(data) {

  var html = '';

  var optionIndex = data.options_with_values.findIndex(function (e) { return e.name == 'color'; });
  var options = data.options_with_values.filter(function (e) { return (e.name).toLowerCase() == 'color'; });
  if (typeof options[0] !== 'undefined') {



    var avaiVariants = [];
    var avaiColors = [];
    var avaiIds = [];
    var avaiImages = [];
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].hasOwnProperty('option3')) {
        if (avaiVariants.indexOf(data['variants'][i]['option3']) == -1) {
          avaiVariants.push(data['variants'][i]['option3']);
          avaiColors.push(data['variants'][i]['option_color']);
          avaiIds.push(data['variants'][i]['id']);
          avaiImages.push(data['variants'][i]['image']);
        }
      }
    }

    if (avaiVariants.length > 1) {

      html += '<div class="col product__colors"><div class="grid grid--tight_guttered grid--bottom grid--right">';

      for (var k = 0; k < avaiVariants.length; k++) {
        // var option = options[0]['values'].filter(function(e) { return e.title == avaiVariants[k]; });
        // if (option.length > 0) {
        // var imageIndex = option[0]['image'];

        if (k < 3) {
          var variantImage = typeof avaiImages[k] !== 'undefined' ? bcsffilter.optimizeImage(avaiImages[k]) : bcSfFilterConfig.general.no_image_url;
          var variantName = avaiVariants[k];
          var swatchId = false;
          var swatchUrl = false;

          // for(var j = 0; j < data['metafields'].length; j++) {
          //     if(data['metafields'][j]['value'].indexOf('SWATCHES') != -1) {
          //         valueArray = data['metafields'][j]['value'].split(':');
          //         swatchValue = valueArray[1];
          //         if(swatchValue == variantName){
          //           swatchId = data['metafields'][j]['namespace'];
          //         }
          //     }
          // }

          // if(swatchId) {
          //   for(var l = 0; l < data['images'].length; l++) {
          //       if(data['images'][l]['id'] == swatchId) {
          //           swatchUrl = data['images'][l]['src'];
          //       }
          //   }
          // }

          html += '<div class="col"><a class="product__color" data-color="' + variantName + '"';
          html += 'href="' + data.url + '?variant=' + avaiIds[k] + '"';
          if (k > 0) {
            html += ' data-hover-img="' + variantImage + '"';
          }

          html += ' data-hover="' + avaiIds[k] + '">';
          if (variantImage) {
            html += '<img class="lazyload" data-src="' + variantImage + '"/>';
          }
          html += '</a></div>';
        }
        // }
      }
      if (avaiVariants.length > 3) {
        var colorTotal = avaiVariants.length - 3;
        html += '<a href="' + data.url + '" class="col show_on_tablet_portrait">+' + colorTotal + '</a>';
      }
      html += '</div>';
      html += '<div class="text_right small_top small_bottom">';
      if (colorTotal) {
        html += '<a href="' + data.url + '" class="hide_on_tablet_portrait">+' + colorTotal + '</a>';
      }

      // for (var j = 0; j < avaiVariants.length; j++) {
      //   html += '<span class="hide" data-color-name="'+avaiIds[j]+'">'+avaiVariants[j]+'</span>';
      // }
      html += '</div></div>';
    }

  }

  return html;
}
/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
/************************** BUILD TOOLBAR **************************/
// Build Pagination
BCSfFilter.prototype.buildPagination = function (totalProduct) {
  // Get page info
  var currentPage = parseInt(this.queryParams.page);
  var totalPage = Math.ceil(totalProduct / this.queryParams.limit);
  // If it has only one page, clear Pagination
  if (totalPage == 1) {
    jQ(this.selector.pagination).html('');
    return false;
  }
  if (this.getSettingValue('general.paginationType') == 'default') {
    var paginationHtml = bcSfFilterTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    jQ(this.selector.pagination).html(paginationHtml);
  }
};
// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function () {
  if (bcSfFilterConfig.custom.show_sorting && bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
    jQ(this.selector.topSorting).html('');
    var sortingArr = this.getSortingList();
    if (sortingArr) {
      var paramSort = this.queryParams.sort || '';
      // Build content
      var sortingItemsHtml = '';
      for (var k in sortingArr) {
        activeClass = '';
        if (paramSort == k) {
          activeClass = 'active';
        }
        sortingItemsHtml += '<li><a href="#" data-sort="' + k + '" class="' + activeClass + '">' + sortingArr[k] + '</a></li>';
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      jQ('.bc-sf-filter-custom-sorting').html(html);
      if (jQ('.bc-sf-filter-custom-sorting').hasClass("bc-sf-filter-sort-active")) {
        jQ('.bc-sf-filter-custom-sorting').toggleClass('bc-sf-filter-sort-active');
      }

      var labelSort = '';
      if (paramSort.length > 0) {
        var labelHandle = 'sorting_' + paramSort.replace(/\-/g, '_');
        labelSort = bcSfFilterConfig.label[labelHandle];
      } else {
        labelSort = bcSfFilterConfig.label.sorting;
      }

      jQ('.bc-sf-filter-custom-sorting label span span').text(labelSort);
    }
  }
};

// Build Sorting event
BCSfFilter.prototype.buildSortingEvent = function () {
  var _this = this;
  jQ('.bc-sf-filter-filter-dropdown a').click(function (e) {
    e.preventDefault();
    onInteractWithToolbar(e, 'sort', _this.queryParams.sort, jQ(this).data('sort'));
  });

  jQ(".bc-sf-filter-custom-sorting > label").click(function () {
    if (!jQ('.bc-sf-filter-filter-dropdown').is(':animated')) {
      jQ('.bc-sf-filter-filter-dropdown').toggle().parent().toggleClass('bc-sf-filter-sort-active');
      jQ('#bc-sf-filter-tree').hide();
    }
  });

  jQ(this.getSelector('filterTreeMobileButton')).click(function () {
    jQ('#bc-sf-filter-top-sorting-mobile .bc-sf-filter-filter-dropdown').hide();
  });
};
// For Toolbar - Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function () {
  var itemHtml = '<span>' + bcSfFilterConfig.label.toolbar_viewas + '</span>';
  itemHtml += '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="bc-sf-filter-display-item bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
  itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="bc-sf-filter-display-item bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
  var topDisplayTypeSelector = jQ(this.getSelector('topDisplayType'));
  var listProductSelector = jQ(this.getSelector('products'));
  topDisplayTypeSelector.html(itemHtml);
  // Active current display type
  topDisplayTypeSelector.find('.bc-sf-filter-display-item').removeClass('active');
  if (this.queryParams.display == 'list') {
    topDisplayTypeSelector.find('.bc-sf-filter-display-list').addClass('active');
    listProductSelector.removeClass('bc-sf-filter-grid-view-items').addClass('bc-sf-filter-list-view-items');
  } else if (this.queryParams.display == 'grid') {
    topDisplayTypeSelector.find('.bc-sf-filter-display-grid').addClass('active');
    listProductSelector.removeClass('bc-sf-filter-list-view-items').addClass('bc-sf-filter-grid-view-items');
  }
};
// Build Display type event
BCSfFilter.prototype.buildDisplayTypeEvent = function () {
  var _this = this;
  var topDisplayTypeSelector = jQ(this.getSelector('topDisplayType'));
  var listProductSelector = jQ(this.getSelector('products'));
  jQ(this.getSelector('topDisplayType') + ' a').click(function (e) {
    e.preventDefault();
    _this.internalClick = true;
    jQ(this).parent().children().removeClass('active');
    jQ(this).addClass('active');
    if (_this.queryParams.display == 'list') {
      topDisplayTypeSelector.find('.bc-sf-filter-display-list').addClass('active');
      listProductSelector.removeClass('bc-sf-filter-grid-view-items').addClass('bc-sf-filter-list-view-items');
    } else if (_this.queryParams.display == 'grid') {
      topDisplayTypeSelector.find('.bc-sf-filter-display-grid').addClass('active');
      listProductSelector.removeClass('bc-sf-filter-list-view-items').addClass('bc-sf-filter-grid-view-items');
    }
    var newUrl = jQ(this).attr('href');
    _this.onChangeData(newUrl, 'display');
  })
};
// Build Show Limit
BCSfFilter.prototype.buildFilterShowLimit = function () {
  if (bcSfFilterConfig.custom.show_limit && bcSfFilterTemplate.hasOwnProperty('showLimitHtml')) {
    jQ(this.selector.topShowLimit).html('');
    var numberList = this.getSettingValue('general.showLimitList');
    if (numberList != '') {
      // Build content
      var showLimitItemsHtml = '';
      var arr = numberList.split(',');
      for (var k = 0; k < arr.length; k++) {
        showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
      }
      var html = bcSfFilterTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
      jQ(this.selector.topShowLimit).html(html);
      // Set value
      jQ(this.selector.topShowLimit + ' select').val(this.queryParams.limit);
    }
  }
};
// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function (colData, apiData) {
  if (bcSfFilterTemplate.hasOwnProperty('breadcrumbHtml')) {
    var breadcrumbItemsHtml = '';
    if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
      var colInfo = colData.collection;
      if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title);
        breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
      } else {
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
      }
    } else {
      breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.getSettingValue('label.defaultCollectionHeader'));
    }
    var html = bcSfFilterTemplate.breadcrumbHtml.replace(/{{breadcrumbItems}}/g, breadcrumbItemsHtml)
    html = html.replace(/{{breadcrumbDivider}}/g, bcSfFilterTemplate.breadcrumbDivider);
    jQ(this.selector.breadcrumb).html(html);
  }
};
/************************** END BUILD TOOLBAR **************************/
function matchHeightImage() {
  jQ('.bc-sf-filter-product-item-main-image').load(function () {
    // var imageContainer = jQ(this).parent();
    // imageContainer.css('width', '100%').css('height', $(this).height());
  }).each(function () {
    if (this.complete) jQ(this).load();
  });
}
// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function (data, eventType) {
  /* start-initialize-bc-al */
  var self = this;
  var alEnable = true;
  if (self.getSettingValue('actionlist.qvEnable') != '' || self.getSettingValue('actionlist.atcEnable') != '') {
    alEnable = self.getSettingValue('actionlist.qvEnable') || self.getSettingValue('actionlist.atcEnable');
  }
  if (alEnable === true && typeof BCActionList !== 'undefined') {
    if (typeof bcActionList === 'undefined') {
      bcActionList = new BCActionList();
    } else {
      if (typeof bcAlParams !== 'undefined' && typeof bcSfFilterParams !== 'undefined') {
        bcActionList.initFlag = false;
        bcActionList.alInit(bcSfFilterParams, bcAlParams);
      } else {
        bcActionList.alInit();
      }
    }
  }
  /* end-initialize-bc-al */
  // Call theme init function
  if (typeof theme !== 'undefined' && typeof theme.init === 'function') {
    $(theme.init);
  }
  // End For List View
};
// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function (data, eventType) {

  $("[data-collection-product]").each((function (_this) {
    return function (index, element) {
      return window.Rubino.views.push(new Rubino.Views.CollectionProduct({
        el: element
      }));
    };
  })(this));


  var _this = this;
  var totalProduct = data.total_product + '<span> ' + bcSfFilterConfig.label.items_with_count_other + '</span>';
  if (data.total_product == 1) {
    totalProduct = data.total_product + '<span> ' + bcSfFilterConfig.label.items_with_count_one + '</span>';
  }
  jQ('#bc-sf-filter-total-product').html(totalProduct);
  matchHeightImage();
  jQ(window).resize(function () {
    matchHeightImage();
  });

  jQ('body').find('.bc-sf-filter-skeleton-button').remove();

  // Prevent double tap on iOS
  var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  if (isiOS) {
    this.isMobile() && jQ(".bc-sf-filter-product-item").find("a").on("touchstart", function () { isScrolling = !1 }).on("touchmove", function () { isScrolling = !0 }).on("touchend", function () { isScrolling || (window.location = jQ(this).attr("href")) });
  }

  // Fix image not loaded on mobile
  (this.isMobile() || null != navigator.userAgent.match(/iPad/i)) && (setTimeout(function () { jQ(".bc-sf-filter-product-item-image img").each(function () { var a = jQ(this).attr("src") + "3"; jQ(this).attr("src", a) }) }, 200), setTimeout(function () { jQ(".bc-sf-filter-product-item-image img").each(function () { var a = jQ(this).attr("src") + "3"; jQ(this).attr("src", a) }) }, 2e3));
};

// Prepare Filter params
BCSfFilter.prototype.prepareFilterParams = function (params, eventType) {
  // Get collection id
  if (!this.queryParams.hasOwnProperty('collection_scope')) {
    if (!this.isSearchPage()) {
      params.collection_scope = parseInt(this.collectionId);
      if (eventType == 'history') {
        var historyData = History.getState().data;
        if (historyData.hasOwnProperty('param') && historyData.param.hasOwnProperty('collection_scope')) {
          params.collection_scope = this.collectionId = parseInt(historyData.param.collection_scope);
        } else {
          params.collection_scope = this.collectionId = parseInt(bcSfFilterConfig.general.collection_id);
        }
      }
    } else {
      params.collection_scope = 0;
    }
  } else {
    params.collection_scope = Array.isArray(this.queryParams.collection_scope) ? this.queryParams['collection_scope'][0] : this.queryParams['collection_scope'];
  }
  // Get product/variant available or not
  if (this.getSettingValue('general.availableAfterFiltering') == true) {
    params.product_available = this.checkExistFilterOptionParam() === true ? true : this.productAvailable;
    params.variant_available = this.checkExistFilterOptionParam() === true ? true : this.variantAvailable;
  } else {
    params.product_available = this.productAvailable;
    params.variant_available = this.variantAvailable;
  }
  // Get Tag value
  if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) params.tag = this.collectionTags;
  // Display filter option items even they return no product
  if (this.getSettingValue('general.showOutOfStockOption')) params.zero_options = true;
  // Build Filter tree or not
  params.build_filter_tree = (typeof eventType !== 'undefined' && this.imutableFilterTree.indexOf(eventType) > -1) ? false : true; // Except events of elements in filter tree, all remaining events do not rebuild filter tree
  // Enable cache when request params doest not have filter option values, "page" param equal to 1 and "sort" param equal to default sorting
  params.check_cache = (this.checkExistFilterOptionParam() === false && params['page'] == 1 && params['sort'] == this.defaultSorting && params['limit'] == this.getSettingValue('general.limit') && !this.isSearchPage() && !this.isVendorPage() && !this.isTypePage()) ? true : false;
  // Turn on price mode
  if (this.getSettingValue('general.priceMode') != '') params['price_mode'] = this.getSettingValue('general.priceMode');
  // Tag mode
  if (this.getSettingValue('general.tagMode') != '') params['tag_mode'] = this.getSettingValue('general.tagMode');
  if (typeof bcSfFilterConfig != 'undefined' && bcSfFilterMainConfig.general.template === "collection.hide-liquidation" && !this.isSearchPage()) {
    if (!params.hasOwnProperty("pf")) params._ = "pf"

    params.pf_t_boostcustom = [];
    params.pf_t_boostcustom.push('boost-liquidation-none');
    params.pf_t_boostcustom.push('boost-liquidation-variants');

    params.check_cache = false;

  } else if (typeof bcSfFilterConfig != 'undefined' && bcSfFilterMainConfig.general.template === "collection.liquidation-only" && !this.isSearchPage()) {
    if (!params.hasOwnProperty("pf")) params._ = "pf"

    params.pf_t_boostcustom = [];
    params.pf_t_boostcustom.push('boost-liquidation-product');
    params.pf_t_boostcustom.push('boost-liquidation-variants');

    params.check_cache = false;
  }
  // Availability Sorting
  if (this.getSettingValue('general.sortingAvailableFirst')) params.sort_first = 'available';
  // Vendor page: Get Vendor param
  if (this.isVendorPage() && params.hasOwnProperty('q')) {
    var vendorParam = this.getSettingValue('general.vendorParam');
    // params[vendorParam] = [params['q'].replace(/\+/g, ' ')];
    params[vendorParam] = [params['q']];
    delete params['q'];
  }
  // Type page: Get Type param
  if (this.isTypePage() && params.hasOwnProperty('q')) {
    var typeParam = this.getSettingValue('general.typeParam');
    params[typeParam] = [params['q']];
    delete params['q'];
  }

  return params;
};


// Build Default layout
function buildDefaultLink(a, b) { var c = window.location.href.split("?")[0]; return c += "?" + a + "=" + b } BCSfFilter.prototype.buildDefaultElements = function (a) { var self = this; if (jQ(self.getSelector('bottomPagination')).length > 0) { jQ(self.getSelector('bottomPagination')).show(); } if (jQ(self.getSelector('topSorting')).length > 0) { jQ(self.getSelector('topSorting')).hide(); } jQ(self.getSelector('products')).attr('data-bc-sort', ''); if (typeof self.removePlaceholderForFilterTree == 'function') { self.removePlaceholderForFilterTree(); } };

BCSfFilter.prototype.prepareProductData = function (data) { var countData = data.length; for (var k = 0; k < countData; k++) { data[k]['images'] = data[k]['images_info']; if (data[k]['images'].length > 0) { data[k]['featured_image'] = data[k]['images'][0] } else { data[k]['featured_image'] = { src: bcSfFilterConfig.general.no_image_url, width: '', height: '', aspect_ratio: 0 } } data[k]['url'] = '/products/' + data[k].handle; var optionsArr = []; var countOptionsWithValues = data[k]['options_with_values'].length; for (var i = 0; i < countOptionsWithValues; i++) { optionsArr.push(data[k]['options_with_values'][i]['name']) } data[k]['options'] = optionsArr; if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) { var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim(); function updateMultiCurrencyPrice(oldPrice, newPrice) { if (typeof newPrice != 'undefined') { return newPrice; } return oldPrice; } data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]); data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]); data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]); data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]); } data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100; data[k]['price'] = data[k]['price_min']; data[k]['compare_at_price'] = data[k]['compare_at_price_min']; data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max']; var firstVariant = data[k]['variants'][0]; if (getParam('variant') !== null && getParam('variant') != '') { var paramVariant = data[k]['variants'].filter(function (e) { return e.id == getParam('variant') }); if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0] } else { var countVariants = data[k]['variants'].length; for (var i = 0; i < countVariants; i++) { if (data[k]['variants'][i].available) { firstVariant = data[k]['variants'][i]; break } } } data[k]['selected_or_first_available_variant'] = firstVariant; var countVariants = data[k]['variants'].length; for (var i = 0; i < countVariants; i++) { var variantOptionArr = []; var count = 1; var variant = data[k]['variants'][i]; var variantOptions = variant['merged_options']; if (Array.isArray(variantOptions)) { var countVariantOptions = variantOptions.length; for (var j = 0; j < countVariantOptions; j++) { var temp = variantOptions[j].split(':'); data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1]; data[k]['variants'][i]['option_' + temp[0]] = temp[1]; variantOptionArr.push(temp[1]) } data[k]['variants'][i]['options'] = variantOptionArr } data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100; data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100 } data[k]['description'] = data[k]['content'] = data[k]['body_html']; if (data[k].hasOwnProperty('original_tags') && data[k]['original_tags'].length > 0) { data[k].tags = data[k]['original_tags'].slice(0); } } return data };

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
  var self = bcsffilter;
  var ext = typeof ext !== 'undefined' ? ext : 'png';
  var version = typeof version !== 'undefined' ? version : '1';
  var prIndex = self.fileUrl.lastIndexOf('?');
  if (prIndex > 0) {
    var filePath = self.fileUrl.substring(0, prIndex);
  } else {
    var filePath = self.fileUrl;
  }
  filePath += fileName + '.' + ext + '?v=' + version;
  return filePath;
}

BCSfFilter.prototype.getFilterData = function (eventType, errorCount) { function BCSend(eventType, errorCount) { var self = bcsffilter; var errorCount = typeof errorCount !== "undefined" ? errorCount : 0; self.showLoading(); if (typeof self.buildPlaceholderProductList == "function") { self.buildPlaceholderProductList(eventType) } self.beforeGetFilterData(eventType); self.prepareRequestParams(eventType); self.queryParams["callback"] = "BCSfFilterCallback"; self.queryParams["event_type"] = eventType; var url = self.isSearchPage() ? self.getApiUrl("search") : self.getApiUrl("filter"); var script = document.createElement("script"); script.type = "text/javascript"; var timestamp = (new Date).getTime(); script.src = url + "?t=" + timestamp + "&" + jQ.param(self.queryParams); script.id = "bc-sf-filter-script"; script.async = true; var resendAPITimer, resendAPIDuration; resendAPIDuration = 2e3; script.addEventListener("error", function (e) { if (typeof document.getElementById(script.id).remove == "function") { document.getElementById(script.id).remove() } else { document.getElementById(script.id).outerHTML = "" } if (errorCount < 3) { errorCount++; if (resendAPITimer) { clearTimeout(resendAPITimer) } resendAPITimer = setTimeout(self.getFilterData("resend", errorCount), resendAPIDuration) } else { self.buildDefaultElements(eventType) } }); document.getElementsByTagName("head")[0].appendChild(script); script.onload = function () { if (typeof document.getElementById(script.id).remove == "function") { document.getElementById(script.id).remove() } else { document.getElementById(script.id).outerHTML = "" } } } this.requestFilter(BCSend, eventType, errorCount) }; BCSfFilter.prototype.requestFilter = function (sendFunc, eventType, errorCount) { sendFunc(eventType, errorCount) };


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem = function (html, iLabel, iValue, fOType, fOId, fOLabel, fODisplayType, fOSelectType, fOItemValue, fOData) { var keepValuesStatic = fOData.hasOwnProperty("keepValuesStatic") ? fOData.keepValuesStatic : false; if (fOType == "review_ratings" && this.getSettingValue("general.ratingSelectionStyle") == "text") { var title = this.getReviewRatingsLabel(fOItemValue.from) } else { var title = this.customizeFilterOptionLabel(iLabel, fOData.prefix, fOType) } if (keepValuesStatic === true) var productNumber = null; else var productNumber = fOItemValue.hasOwnProperty("doc_count") ? fOItemValue.doc_count : 0; html = html.replace(/{{itemLabel}}/g, this.buildFilterOptionLabel(iLabel, productNumber, fOData)); html = html.replace(/{{itemLink}}/g, this.buildFilterOptionLink(fOId, iValue, fOType, fODisplayType, fOSelectType, keepValuesStatic)); html = html.replace(/{{itemValue}}/g, encodeURIParamValue(iValue)); html = html.replace(/{{itemTitle}}/g, title); html = html.replace(/{{itemFunc}}/g, "onInteractWithFilterOptionValue(event, this, '" + fOType + "', '" + fODisplayType + "', '" + fOSelectType + "', '" + keepValuesStatic + "')"); html = this.checkFilterOptionSelected(fOId, iValue, fOType, fODisplayType) ? html.replace(/{{itemSelected}}/g, "selected") : html.replace(/{{itemSelected}}/g, ""); var htmlElement = jQ(html); htmlElement.children().attr({ "data-id": fOId, "data-value": encodeURIParamValue(iValue), "data-parent-label": fOLabel, "data-title": title, "data-count": productNumber }); if (fOType != "collection") { htmlElement.children().attr("rel", "nofollow") } if (fOType == "collection") htmlElement.children().attr("data-collection-scope", fOItemValue.key); return jQ(htmlElement)[0].outerHTML };
/* end-boost-2.4.8 */


BCSfFilter.prototype.buildFilterOptionLink = function (paramType, paramValue, filterType, displayType, selectType, keepValuesStatic) {
  var link = '';
  // Build Custom link, using in advanced customization like building range for filter option
  link = this.buildFilterOptionCustomLink(paramType, paramValue, filterType, displayType, selectType, keepValuesStatic);
  if (link != '') return link;

  // Get collection information: Id and Scope
  if (filterType == 'collection') {
    var collectionElements = paramValue.split(':');
    var collectionScope = collectionElements[1];
    paramValue = collectionElements[0];
  }

  if (filterType == 'collection' && !this.isSearchPage()) {
    var keepValuesStatic = typeof keepValuesStatic !== 'undefined' ? keepValuesStatic : null;
    // When url has "/" at the end of pathname, slice it
    var pathName = window.location.pathname;
    if (pathName.slice(-1) == '/') {
      pathName = pathName.substring(0, pathName.length - 1);
    }
    // Sub Category
    if (paramType == 'pf_cs_collection') {
      if (window.location.href.indexOf(paramValue) > -1) {
        link = pathName.replace(paramValue, '') + paramValue.split('/')[0];
      } else {
        link = '/' + pathName.split('/')[1] + '/' + paramValue;
      }
    } else {
      if (pathName != '') {
        var newPathName = '';
        var pathNameArr = pathName.split('/');
        if (pathNameArr.length == 3 ||
          pathNameArr.length === 4 && !bcSfFilterConfig.general.published_locales[bcSfFilterConfig.general.current_locale]) {
          newPathName = pathNameArr.slice(0, -1).join('/') + '/' + paramValue;
        } else {
          // If pathName contains sub-category
          if (pathNameArr.length > 3) {
            newPathName = pathNameArr.slice(0, -2).join('/') + '/' + paramValue;
          }
        }
        link = keepValuesStatic === true ? window.location.href.split("?")[0] : window.location.href;
        link = link.replace(pathName, newPathName);
      }
    }
  } else {
    link = window.location.href.replace(/\+/g, '%20');
    if (window.location.search.length == 0) {
      link += '?_=' + this.prefix;
    } else if (getParam('_') === null) {
      var links = link.split('?');
      link = links[0] + '?_=' + this.prefix;
      if (links.length > 1) link += '&' + links[1];
    }
    if (displayType == 'range' && filterType !== 'price' && filterType !== 'variants_price' && filterType.indexOf('range_slider') == -1) {
      // Remove old params
      if (this.queryParams.hasOwnProperty(paramType)) {
        var oldParams = this.queryParams[paramType];
        for (var k in oldParams) {
          link = link.replace('&' + paramType + '=' + encodeURIParamValue(oldParams[k]), '');
        }
      }
      // Add new params
      if (paramValue != '') {
        var newParam = '';
        var valueArr = paramValue.split(',');
        for (var k in valueArr) {
          if (valueArr[k] != '') {
            newParam += '&' + paramType + '=' + encodeURIParamValue(valueArr[k]);
          }
        }
        if (newParam != '') link = link + newParam;
      }
    } else {
      if (paramValue !== '' && paramValue !== null) {
        var newParam = '&' + paramType + '=' + encodeURIParamValue(paramValue);
        if ((displayType == 'range' || selectType == 'single') && this.queryParams.hasOwnProperty(paramType)) {
          var oldParam = '&' + paramType + '=' + encodeURIParamValue(this.queryParams[paramType][0]);
          link = window.location.href.replace(oldParam, newParam);
        } else {
          // Check the param whether exists in url
          // If Yes, remove this param from url
          var currentUrl = window.location.href.replace(/\+/g, '%20') + '&';
          if (currentUrl.indexOf(newParam + '&') > -1) {
            link = currentUrl.replace(newParam + '&', '&');
            if (link[link.length - 1] == '&') link = link.slice(0, -1);
          }
          // If No, append this param to url
          else {
            var link = window.location.href.replace(/\+/g, '%20');
            if (window.location.search.length === 0) {
              link += '?_=' + this.prefix;
            } else {
              link = window.location.href.replace(/\+/g, '%20');
              if (!this.queryParams.hasOwnProperty('_')) {
                link += '&_=' + this.prefix;
              }
            }
            link += newParam;
            // link = (window.location.search.length === 0 ? link + '?_=' + this.prefix : window.location.href) + newParam;
          }
        }
      } else {
        link = window.location.href.replace(/\+/g, '%20').replace('&' + paramType + '=' + encodeURIParamValue(this.queryParams[paramType]), '');
      }
    }
  }

  // Assign collection_scope param to url in Search page when selecting Collection filter option
  if (filterType == 'collection' && this.isSearchPage()) {
    link = link.replace('&collection_scope=' + this.queryParams['collection_scope'], '');
    link += '&collection_scope=' + collectionScope;
  }

  // AND condition
  var andParam = '&' + paramType + '_and_condition=true';
  if (link.indexOf(andParam) == -1) {
    var useAndCondition = jQ('[data-id="' + paramType + '"]').attr('data-and-condition');
    if (useAndCondition) link += andParam;
  } else {
    if (link.indexOf(paramType + '=') == -1) {
      link = link.replace(andParam, '');
    }
  }

  // show EXACT rating
  if (filterType == 'review_ratings') {
    var exactRatingParam = '&' + paramType + '_show_exact_rating=true';
    if (link.indexOf(exactRatingParam) == -1) {
      var useExactRating = jQ('[data-id="' + paramType + '"]').attr('data-exact-rating');
      if (useExactRating) link += exactRatingParam;
    } else {
      if (link.indexOf(paramType + '=') == -1) {
        link = link.replace(exactRatingParam, '');
      }
    }
  }

  // Remove pagination
  link = removePageParamFromUrl(link);

  // Customize filter option link
  link = this.customizeFilterOptionLink(link, paramType, paramValue, filterType, displayType, selectType, keepValuesStatic);
  return link;
};